import {
  Breadcrumbs,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Link,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SortableTable from "../../../Components/SortableTable";
import TicketEntry from "../../../Components/TicketEntry";
import Title from "../../../Components/Title";
import {
  ECABIN,
  formatTimeWithTZOffset,
  getToken,
  requestErrorHandler,
  TICKET_PRIORITIES,
  ticketListRowStyle,
  ticketStates,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
import { useStyles } from "../../../Utils/Styles";
const server = EnvSettings.server;

export default function MaintenanceTickets(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [showTicketEntry, setShowTicketEntry] = useState(false);
  const [refreshList, setRefreshList] = useState("dsfsdfds");
  const [tickets, setTickets] = useState();
  const [selectedTicket, setSelectedTicket] = useState();
  const [filteredList, setFilteredList] = useState();
  const [searchVal, setSearchVal] = useState();
  const [filterStates, setFilterStates] = useState([...ticketStates]);
  const history = useHistory();

  const dispatch = useDispatch();

  let handleRowClick = (data) => {
    if (data) {
      setSelectedTicket(data);
      setShowTicketEntry(true);
    }
  };

  const handleScrollClick = (event, id) => {};

  useEffect(() => {
    setTickets();
    const getTickets = () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
        }),
      };
      fetch(server + "/get_tickets", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          requestErrorHandler(result, dispatch);
          if (!result.error) {
            if (result.tickets.length !== 0) {
              setTickets(result.tickets);
            }
          }
        });
    };
    getTickets();
  }, [dispatch, refreshList]);

  useEffect(() => {
    if ((searchVal || filterStates.length) && tickets) {
      var arr = tickets.filter((ti) => {
        if (!ti) {
          return false;
        }
        if (searchVal && filterStates.length) {
          return (
            !!Object.keys(ti).find(
              (k) =>
                ti[k] &&
                (String(ti[k])
                  .toLowerCase()
                  .includes(searchVal.toLowerCase()) ||
                  (typeof ti[k] === "object" &&
                    JSON.stringify(ti[k])
                      .toLowerCase()
                      .includes(searchVal.toLowerCase())))
            ) && filterStates.find((s) => ti.state === s.value)
          );
        } else if (searchVal) {
          return !!Object.keys(ti).find(
            (k) =>
              (ti[k] &&
                String(ti[k])
                  .toLowerCase()
                  .includes(searchVal.toLowerCase())) ||
              (typeof ti[k] === "object" &&
                JSON.stringify(ti[k])
                  .toLowerCase()
                  .includes(searchVal.toLowerCase()))
          );
        }
        return filterStates.find((s) => ti.state === s.value);
      });

      setFilteredList(arr);
    } else {
      setFilteredList(tickets);
    }
  }, [searchVal, tickets, filterStates]);

  return (
    <Grid container spacing={3}>
      <TicketEntry
        showTicketEntry={showTicketEntry}
        setShowTicketEntry={setShowTicketEntry}
        selectedTicket={selectedTicket}
        setSelectedTicket={setSelectedTicket}
        showHeader={true}
        showSearch={true}
        setRefreshList={setRefreshList}
      />
      <Grid item xs={12}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            style={{ cursor: "pointer" }}
            onClick={() => {
              history.push("/cpanel/maintenance");
            }}
          >
            {t("maintenance.header")}
          </Link>
          <Typography>{t("maintenance.ticketArchive")}</Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  setSelectedTicket();
                  setShowTicketEntry(true);
                }}
              >
                {t("newTicket")} +
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={12}>
              <Title>{t("deviceDetails.maintenanceTickets")}</Title>
            </Grid>
            <Grid item container xs={12} spacing={1}>
              <Grid item>
                {ticketStates.map((o) => (
                  <FormControlLabel
                    key={o.label}
                    defaultChecked={true}
                    control={
                      <Checkbox
                        color="primary"
                        onChange={(e, v) => {
                          if (v) {
                            setFilterStates([...filterStates, o]);
                            return;
                          }
                          setFilterStates([
                            ...filterStates.filter((f) => f !== o),
                          ]);
                        }}
                        defaultChecked={o.value}
                      />
                    }
                    label={t("ticketList." + o.value)}
                  />
                ))}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  style={{ marginTop: 10 }}
                  variant="outlined"
                  label={t("search")}
                  fullWidth
                  onChange={(e) => {
                    setSearchVal(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                {filteredList ? (
                  <SortableTable
                    tableLayout={"fixed"}
                    headCells={[
                      {
                        id: "attachments",
                        hideFromCsv: true,
                        width: 32,
                        label: "",
                      },
                      {
                        id: "expenses",
                        hideFromCsv: true,
                        width: 32,
                        label: "",
                      },
                      {
                        id: "priority",
                        numeric: false,
                        disablePadding: false,
                        label: t("ticketList.priority"),
                      },
                      {
                        id: "Device.serialNumber",
                        numeric: false,
                        disablePadding: false,
                        label: t("serialNumber"),
                      },
                      {
                        id: "description",
                        numeric: false,
                        disablePadding: false,
                        label: t("ticketList.description"),
                      },
                      {
                        id: "action",
                        numeric: false,
                        disablePadding: false,
                        label: t("ticketList.action"),
                      },
                      {
                        id: "details",
                        numeric: false,
                        disablePadding: false,
                        label: t("ticketList.details"),
                      },
                      {
                        id: "state",
                        numeric: false,
                        disablePadding: false,
                        label: t("ticketList.state"),
                      },
                      {
                        id: "User.fullName",
                        numeric: false,
                        disablePadding: false,
                        label: t("ticketList.editor"),
                      },
                      {
                        id: "createdAt",
                        numeric: false,
                        disablePadding: false,
                        label: t("createdAt"),
                      },
                      {
                        id: "updatedAt",
                        numeric: false,
                        disablePadding: false,
                        label: t("updatedAt"),
                      },
                    ]}
                    getRowStyle={ticketListRowStyle}
                    defaultSortRow={"updatedAt"}
                    handleRowClick={handleRowClick}
                    handleScrollClick={handleScrollClick}
                    maxDataLength={30}
                    tableData={filteredList}
                    rowsPerPage={200}
                    downloadButton={true}
                    header={t("deviceDetails.maintenanceTickets")}
                    specialDataFormatting={[
                      {
                        id: "attachments",
                        format: (data) => {
                          return data ? (
                            <Tooltip title={"This ticket has attached media"}>
                              <AttachFileIcon
                                color="primary"
                                style={{ fontSize: 20 }}
                              />
                            </Tooltip>
                          ) : (
                            ""
                          );
                        },
                      },
                      {
                        id: "expenses",
                        format: (data) => {
                          return data ? (
                            <Tooltip title={"This ticket has expenses"}>
                              <AttachMoneyIcon
                                color="primary"
                                style={{ fontSize: 20 }}
                              />
                            </Tooltip>
                          ) : (
                            ""
                          );
                        },
                      },
                      {
                        id: "priority",
                        format: (data) => {
                          return Object.keys(TICKET_PRIORITIES).find(
                            (f) => TICKET_PRIORITIES[f] === data
                          );
                        },
                      },
                      {
                        id: "state",
                        format: (data) => {
                          return t("ticketList." + data);
                        },
                      },
                      {
                        id: "createdAt",
                        format: (data) => {
                          return formatTimeWithTZOffset(data, ECABIN);
                        },
                      },
                      {
                        id: "updatedAt",
                        format: (data) => {
                          return formatTimeWithTZOffset(data, ECABIN);
                        },
                      },
                    ]}
                  />
                ) : (
                  <CircularProgress />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
